//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import { MediaFilterParamKey } from '@apis/content-library/contentLibraryApiModel';

export interface FilterSection<T extends FilterValue> {
  options: FilterOption<T>[];
  paramKey: MediaFilterParamKey;
}

export interface FilterOption<T extends FilterValue> {
  label: string;
  isSelected: boolean;
  value: T;
  trackingId?: string;
}

export interface NestedFilterOption<T extends FilterValue>
  extends FilterOption<T> {
  subOptions?: FilterOption<T>[];
  isEnabled: boolean;
}

export type FilterValue = string | number | boolean;

export const FilterSectionTitle: Record<MediaFilterParamKey, string> = {
  createdAfter: '',
  dateRange: 'Date Range',
  distribution: 'Distributed to',
  filter: '',
  hasLabels: 'Labels',
  hasProducts: 'Product Tags',
  igHashtags: 'Hashtags',
  igUsernames: 'Usernames',
  isDistributed: 'Distribution',
  isScheduled: '',
  itemTypes: '',
  itemId: '',
  labels: 'Labels',
  mediaItemTypes: 'Media Type',
  networks: 'Networks',
  orientation: 'Orientation',
  rightsStatuses: 'Rights',
  spamFiltering: 'Spam Filtering',
  searchText: '',
  semanticTags: 'Visual Tags',
  userIds: '',
  includeMissingMedia: '',
};
